export default "__VITE_ASSET__D7h7HwOS__"